// The CPF as Effect Schema, decoding to the same branded type as the
// `@finnest/core/schemas/br` Zod schema, so a value flows unchanged between
// Effect owners and the code still on Zod.
import { Schema } from 'effect';
import type { Cpf as CpfType } from '../../../schemas/br/core/cpf.ts';
import { validateCpfDigits } from '../../../schemas/br/core/validators.ts';

const CPF = /^\d{11}$/u;

/** Cadastro de Pessoas Físicas: 11 digits, no punctuation, valid check digits. Personal data. */
export const Cpf = Schema.String.pipe(
  Schema.refine((value): value is CpfType => CPF.test(value) && validateCpfDigits(value), {
    identifier: 'Cpf',
    expected: 'a CPF of 11 digits with valid check digits',
  }),
);
export type Cpf = typeof Cpf.Type;
